/** `YYYY-MM-DD` from a date input to the ISO instant the staff API takes (UTC day bounds). */
export function dateToInstant(date: string, endOfDay: boolean): string | undefined {
  if (!/^\d{4}-\d{2}-\d{2}$/.test(date)) return undefined
  const start = Date.parse(`${date}T00:00:00Z`)
  if (!Number.isFinite(start)) return undefined
  // `to` is exclusive on the server's side of a day boundary: the next midnight covers the whole day.
  return new Date(endOfDay ? start + 86_400_000 : start).toISOString()
}
